import {
  AppButton,
  AppCard,
  AppCardBody,
  AppText,
  kindredFontFamilies,
} from "../../ui-foundation";
import { KINDRED_SUPPORT_EMAIL } from "../../shared/support";
import AppStoreBadge from "@/components/AppStoreBadge";

const ANDROID_LINKS = [
  {
    href: `mailto:${KINDRED_SUPPORT_EMAIL}?subject=${encodeURIComponent("Kindred Android access request")}&body=${encodeURIComponent("Please add this Google Play email address to the Kindred Android test:\n\n")}`,
    label: "Request Android access",
    tone: "primary" as const,
  },
];

type BetaJoinCardProps = {
  title?: string;
  className?: string;
  id?: string;
};

export default function BetaJoinCard({
  title = "Get Kindred",
  className = "",
  id,
}: BetaJoinCardProps) {
  return (
    <AppCard id={id} className={`mx-auto w-full max-w-5xl scroll-mt-8 ${className}`.trim()}>
      <AppCardBody className="px-6 py-6" gap="$lg">
        <AppText
          className="text-center"
          fontFamily={kindredFontFamilies.display}
          fontSize="$hero"
          lineHeight="$hero"
          letterSpacing="$hero"
          color="$heading"
        >
          {title}
        </AppText>
        <div className="grid w-full gap-4 lg:grid-cols-2">
          <AppCard backgroundColor="$background">
            <AppCardBody className="h-full min-h-[160px] px-5 py-5" alignItems="center" justifyContent="center">
              <div className="flex w-full justify-center">
                <AppStoreBadge />
              </div>
            </AppCardBody>
          </AppCard>

          <AppCard backgroundColor="$background">
            <AppCardBody className="h-full px-5 py-5" gap="$md">
              <AppText
                fontFamily={kindredFontFamilies.sansBold}
                fontSize="$sm"
                lineHeight="$sm"
                textTransform="uppercase"
                letterSpacing={2}
                color="$primary"
                opacity={0.72}
              >
                Android access
              </AppText>
              <AppText fontFamily={kindredFontFamilies.sansBold} fontSize="$lg" lineHeight="$lg" color="$heading">
                Join the Android test
              </AppText>
              <AppText color="$colorMuted" fontSize="$sm" lineHeight={22}>
                Email us and include the email address you use for Google Play so we can add the right account. You can
                send the request from any email address.
              </AppText>
              <div className="flex w-full flex-col gap-3">
                {ANDROID_LINKS.map((link) => (
                  <AppButton key={link.href} asChild tone={link.tone} size="lg">
                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                      {link.label}
                    </a>
                  </AppButton>
                ))}
              </div>
            </AppCardBody>
          </AppCard>
        </div>
      </AppCardBody>
    </AppCard>
  );
}
